export default __webpack_public_path__ + "static/media/mastercard.7e382641.svg";